import _ from 'lodash';
import actionTypes from '../actions/action_types';

const initialState = {
  user: null,
};

export default function reducer(state = initialState, action) {
  let result;

  switch (action.type) {
    case actionTypes.USER_LOADED: {
      const { user } = action.payload;

      result = _.assign({}, state, { user });
      break;
    }

    case actionTypes.LOGOUT: {
      result = _.assign({}, initialState);
      break;
    }

    default: {
      result = _.assign({}, state);
    }

  }

  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js